module.exports = __webpack_public_path__ + "img/foward.68456654.svg";